export const KUBEARCHIVE_PATH_PREFIX = 'plugins/kubearchive';
export const KUBEARCHIVE_RESOURCE_LIMIT = 30;
export const KUBEARCHIVE_TAIL_LINES = 500;
